import { ArrowLeft } from 'lucide-react';

const content = {
  pl: {
    nav: {
      work: "Prace",
      about: "Profil",
      contact: "Kontakt"
    },
    hero: {
      titleLine1: "Projektant",
      titleLine2: "Graficzny",
      role: "Projektant graficzny",
      bio: "Oferuję kompleksowe projektowanie graficzne, które przekłada historię Twojej marki na konkretne, funkcjonujące na rynku narzędzia."
    },
    work: {
      header: "Ostatnie prace",
      dateRange: "2025",
      archiveLink: "Zobacz Wszystkie"
    },
    archive: {
      title: "Wszystkie prace",
      subtitle: "Wszystkie Prace 2020 — 2025",
      back: ( <> <ArrowLeft size={14} /> Powrót </> ),
      close: "Powrót",
      check: "Sprawdź"
    },
    about: {
      title: "O Mnie",
      mainText: 'Projektuję rozwiązania, które są użyteczne i zrozumiałe dla odbiorcy. Zanim postawię pierwszą kreskę, zadaję pytania. Analizuję Twoją grupę docelową i konkurencję, aby stworzyć projekt, który nie tylko cieszy oko, ale przede wszystkim realizuje Twoje założenia biznesowe.',
      servicesTitle: "Usługi",
      services: ["Loga i Branding", "Strony WWW i Banery", "Ulotki i Wizytówki", "Wideo"],
      longTermPartnershipsTitle: "Długoterminowe Współprace",
      longTermPartnerships:["LUX Barber", "Konieczny Fizjoterapia", "EB Cars", "Obsessive Hair"],
    },
    contact: {
      top: "Napisz do mnie"
    }
  },
  en: {
    nav: {
      work: "Work",
      about: "Profile",
      contact: "Contact"
    },
    hero: {
      titleLine1: "Graphic",
      titleLine2: "Designer",
      role: "Graphic Designer",
      bio: "I offer comprehensive design solutions that turn your brand story into specific tools that perform in the market."
    },
    work: {
      header: "Recent Work",
      dateRange: "2025",
      archiveLink: "See all"
    },
    archive: {
      title: "All Projects",
      subtitle: "All Projects 2020 — 2025",
      back: ( <> <ArrowLeft size={14} /> Back to home </> ),
      close: "Back to home",
      check: "Details"
    },
    about: {
      title: "About Me",
      mainText: 'I design solutions that are functional and intuitive for the user. Before I put pen to paper, I ask questions. I analyze your target audience and competitors to deliver a design that is visually appealing and—most importantly—achieves your business objectives.',
      servicesTitle: "Services",
      services: ["Logo & Branding", "Websites & Banners", "Flyers & Business Cards", "Video"],
      longTermPartnershipsTitle: "Lont-Term Parnerships",
      longTermPartnerships:["LUX Barber", "Konieczny Physiotherapy", "EB Cars", "Obsessive Hair"],
    },
    contact: {
      top: "Get in touch"
    }
  }
};

export default content;